import { localeData } from "moment";
import React, { useEffect, useState } from "react";
import imgGizi1 from "../../../assets/img_major02_1.jpg";
import imgGizi2 from "../../../assets/img_major02_2.jpg";
import imgGizi3 from "../../../assets/img_major02_3.jpg";

const MajorTab2 = props => {
    return (
        <>
            {/* 기지국/중계기 운용관리 */}
            <div className="tab-cont">
                <h2 className="major-in-h2">
                    BUSINESS <em>사업소개</em>
                </h2>
                <p className="major-sbj">{props.title}</p>
                <div className="person-gray-wrap gray-back-bg">
                    <div className="major-img-wrap">
                        <ul>
                            <li>
                                <img src={imgGizi1} alt="이미지" />
                            </li>
                            <li>
                                <img src={imgGizi2} alt="이미지" />
                            </li>
                            <li>
                                <img src={imgGizi3} alt="이미지" />
                            </li>
                        </ul>
                    </div>
                    <div className="mojor-business-wrap">
                        {/* <p className="cate">주요사업 업무</p> */}
                        <ul className="list">
                            <li className="hoverWraps">
                                <p className="hoverText">국사 내 정류기, 축전지, 발전기 등 전원시설 점검 및 장애 조치</p>
                                <div className="hoverNextContents">
                                    <div className="inner">
                                        <p>- 정기/부정기 전원시설 정밀점검 및 불량시설 사전 발췌 등 B/S 업무</p>
                                        <p>- 고장진단, 시설개선, 전원시설 긴급정비 및 장애조치 등 A/S 업무</p>
                                    </div>
                                </div>
                            </li>
                            <li className="hoverWraps">
                                <p className="hoverText">국사 별 전원반, 비상발전기 등 수배전시설 DB 현행화 및 관리</p>
                                <div className="hoverNextContents">
                                    <div className="inner">
                                        <p>- 경보관리(ELITE, BIMS, OPMS), 자산 및 이력관리(ePower, NMS) 등 운용시스템 관리</p>
                                        <p>- 재해/재난 대비 긴급복구용 이동형 발전차 및 발전기 운용 관리</p>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>
                    {/* <p className="mojor-text">이동국(가입자단말기)과 이동전화 교환국 사이에 위치하여 이동국과의 무선전송과 교환국의 요청 있을 경우 통화중인 이동국의 신호강도를 측정하여 제공함으로써 이동전화 교환국이 이동국의 이동상황을 파악하는데 필요한 정보를 제공합니다.</p>

                    <p className="major-sbj">기지국</p>
                    <p className="mojor-text">기지국은 기저대역 신호처리, 유무선 변환 및 무선신호의 송수신 등을 수행하여 가입자 단말기와 CAI(COMMON AIR INTERFACE)로 직접 연결되는 망 종단장치입니다.</p> */}
                </div>
            </div>
        </>
    );
};

export default MajorTab2;
